import 'leaflet';
import * as L from 'leaflet';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import { MapLayer, withLeaflet } from 'react-leaflet';
class MarkerClusterGroup extends MapLayer {
    createLeafletElement({ children, leaflet, ...props }) {
        const layerContainer = L.markerClusterGroup(props);
        this.contextValue = {
            map: leaflet.map,
            layerContainer,
        };
        return layerContainer;
    }
}
export default withLeaflet(MarkerClusterGroup);
export const markerClusterField = (cluster) => {
    return L.divIcon({
        html: '<div  class="marker-cluster-field"><span  class="marker-cluster-field">' +
            cluster.getChildCount() +
            '</span></div>',
        className: 'marker-cluster-field',
        iconSize: [40, 40],
    });
};
//# sourceMappingURL=MarkerClusterGroup.js.map